"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubSupportPlacementTrads = void 0;
exports.ESubSupportPlacementTrads = {
    actionFondsActionsEtrangerer: "Actions/fonds action étranger",
    actionFondsActionsFrancais: "Action/fonds actions français",
    assuranceVie: "Assurance vie",
    compteTitresPEA: "Compte titres/PEA",
    epargneSalariale: "Epargne salariale",
    immobilierDirect: "Immobilier direct",
    liquidite: "Liquidité",
    monetaire: "Monétaire",
    obligations: "Obligations",
    privateEquity: "Private Equity",
    scpiOpci: "SCPI / OPCI",
    cac40: "CAC 40",
    euronextEurolist: "Euronext Eurolist",
    alternext: "Alternext",
};
